import { Helmet } from "react-helmet-async";

/**
 * Per-route SEO tags. Real users mount React and this replaces the head.
 * Bots typically get the Pages Function prerender first (bigger effect),
 * but this covers Google's live JS-rendering pass + social share cards.
 */
export default function Seo({
  title,
  description,
  canonical,
  image,
  noindex = false,
  jsonLd = null,
}) {
  const t = title ? `${title} — TOXIC STREET` : "TOXIC/STREET — DISCIPLINE OVER EVERYTHING · Rebel Streetwear";
  const d = description || "TOXIC STREET — rebel streetwear label. Limited-drop graphic tees, hoodies, and accessories built for kids who refuse to fit in. Free US shipping over $100. Stay dangerous.";
  const url = canonical || (typeof window !== "undefined" ? window.location.origin + window.location.pathname : "https://toxicstreet.co/");
  const img = image || "https://toxicstreet.co/img/alleyway-hoodie.webp";

  return (
    <Helmet>
      <title>{t}</title>
      <meta name="description" content={d} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="TOXIC/STREET" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:image" content={img} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t} />
      <meta name="twitter:description" content={d} />
      <meta name="twitter:image" content={img} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
